'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Card,
   Flex,
   Input,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
   Thead,
   Th,
   Grid,
   GridItem,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import nodata from 'assets/img/nfts/no data.svg';
import { Button } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import { useDispatch, useSelector } from 'react-redux';
import { getReportFormat, getStoreStock } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import { useUser } from '../../../../contexts';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useBusinessType, useGlobal } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { motion } from 'framer-motion';
// import { LuCirclePlus, LuRefreshCcw } from 'react-icons/lu';
import { HiOutlinePlusCircle, HiOutlineRefresh } from 'react-icons/hi';
import { storeStockType } from 'constants';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdExpand } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IoFilterOutline } from 'react-icons/io5';
import { LucideEdit } from 'lucide-react';
import ColumnShowHide from '../components/Columnshowhide';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import SalesDetail from './SalesDetail';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const Stock = () => {
   const dispatch = useDispatch();
   const columnHelper = createColumnHelper();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { colorMode } = useColorMode();
   const isDarkMode = colorMode === 'dark';
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const { companyList } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const [stockTypeSelected, setStockTypeSelected] = useState(storeStockType[1]);
   const { businessTypes } = useBusinessType();
   const [companyFilter, setCompanyFilter] = useState([]);
   const dbName = localStorage.getItem('dbName');
   const [searchQuery, setSearchQuery] = useState('');
   const [allExpanded, setAllExpanded] = useState(false);
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', 'white');
   const [isLoading, setIsLoading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const searchTimeoutRef = useRef(null);
   const [lastApiCall, setLastApiCall] = useState('');
   const wrapperRef = useRef();
   const [expanded, setExpanded] = useState(false);
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [editData, setEditData] = useState({});
   const [showHideData, setShowHideData] = useState({});
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else {
         return {};
      }
   });
   const { user } = useUser();
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const IssueRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.inventoryissue
      : null;
   const ReceiveRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.inventoryreceive
      : null;
   const account = useSelector((state) => state.account.single);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const IssueSingle = useSelector((state) => state.issueInventory?.single);
   const ReceiveSingle = useSelector((state) => state.receiveInventory?.single);
   const salesReport = useSelector((state) => state.reports?.storeStock || []);

   const { viewDetail, paginate } = useMemo(() => {
      let data = null;
      let pagination = null;

      switch (entityType) {
         case 'saleinvoice':
            data = viewDatasi;
            pagination = viewDatasi?.pagination;
            break;
         case 'purchaseinvoice':
            data = viewDatapi;
            pagination = viewDatapi?.pagination;
            break;
         case 'issueinventory':
            data = IssueSingle;
            break;
         case 'receiveinventory':
            data = ReceiveSingle;
            break;
         default:
            data = null;
            pagination = null;
      }

      console.log('ViewDetail Debug:', { entityType, data, hasLineitems: data?.lineitems }); // Debug

      return { viewDetail: data, paginate: pagination };
   }, [entityType, viewDatasi, viewDatapi, IssueSingle, ReceiveSingle]);

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter],
   );

   // State for expanded sections
   const [expandedSections, setExpandedSections] = useState({
      onlyReceived: true,
      storeIssued: true,
      partyIssued: true,
      storeRepairingReceived: true,
      partyPendingSales: true,
      partyRepairingSold: true,
      STORE_ISSUED: true,
   });

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const companyOptions = useMemo(() => {
      if (!companyList?.length) return [];
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const makeApiCall = useCallback(
      (params) => {
         const apiKey = JSON.stringify(params);

         if (apiKey === lastApiCall) {
            return;
         }

         setLastApiCall(apiKey);
         dispatch(getStoreStock(params));
      },
      [dispatch, lastApiCall],
   );

   const throttledApiCall = useCallback(
      (() => {
         let lastCall = 0;
         return (params) => {
            const now = Date.now();
            if (now - lastCall >= 300) {
               lastCall = now;
               makeApiCall(params);
            }
         };
      })(),
      [makeApiCall],
   );

   const [columnVisibility, setColumnVisibility] = useState(() =>
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const columns = useMemo(
      () =>
         columnsReportsSalesDetail
            .filter((column) => columnVisibility[column.id])
            .map((column) =>
               columnHelper.accessor(column.id, {
                  id: column.id,
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color="gray.400">
                        {column.header}
                     </Text>
                  ),
                  cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
               }),
            ),
      [columnHelper, columnVisibility],
   );

   const table = useReactTable({
      data: salesReport,
      columns,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   useEffect(() => {
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      if (
         stockTypeSelected?.value &&
         dateRange?.fromDate &&
         dateRange?.toDate &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(id))
      ) {
         const params = {
            companyIds: companyIds.toString(),
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate,
            type: stockTypeSelected?.value,
            search: searchQuery.trim(),
         };

         throttledApiCall(params);
      }
   }, [companyFilter, stockTypeSelected, dateRange, searchQuery, throttledApiCall]);

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
   }, []);

   const handleRefresh = useCallback(() => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      try {
         if (dateRange?.fromDate && dateRange?.toDate && companyIds.length > 0) {
            const params = {
               companyIds: companyIds.toString(),
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               type: stockTypeSelected?.value,
            };
            makeApiCall(params);
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   }, [companyFilter, dateRange, stockTypeSelected, makeApiCall]);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions || []);
   }, []);

   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList, storedCompanyId]);

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   useEffect(() => {
      if (businessTypes?.businessType === 'MOBILE') {
         const option = { value: storeStockType[0].id, label: storeStockType[0].name };
         setStockTypeSelected(option);
      }
   }, [businessTypes]);

   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   }, []);

   const formatStatusTypeName = useCallback((statusType) => {
      const nameMap = {
         onlyReceived: 'Only Received',
         storeIssued: 'Store Issued',
         partyIssued: 'Party Issued',
         storeRepairingReceived: 'Store Repairing',
         partyPendingSales: 'Pending Sales',
         partyRepairingSold: 'Repairing Sold',
         STORE_ISSUED: 'Store Issued',
      };
      return nameMap[statusType] || statusType;
   }, []);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   const expandAll = useCallback(() => {
      setExpandedSections({
         onlyReceived: true,
         storeIssued: true,
         partyIssued: true,
         storeRepairingReceived: true,
         partyPendingSales: true,
         partyRepairingSold: true,
         STORE_ISSUED: true,
      });
      setAllExpanded(true);
   }, []);

   const collapseAll = useCallback(() => {
      setExpandedSections({
         onlyReceived: false,
         storeIssued: false,
         partyIssued: false,
         storeRepairingReceived: false,
         partyPendingSales: false,
         partyRepairingSold: false,
         STORE_ISSUED: false,
      });
      setAllExpanded(false);
   }, []);
   const allowedDefNames = ['SalesDetailDate', 'SalesDetailParty', 'SalesDetailBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));

   const dynamicValues = dynamicOptions.map((option) => option.value);
   console.log('dynamicValues', dynamicValues);

   const dynamicOptionValues = dynamicOptions.find((option) => option.value === stockTypeSelected);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const isStaticReportType = stockTypeSelected;

   const getStockReportColumns = (statusType) => {
      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         // First try to find by defName, then by title
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            // Return default values if no customization found or for static report types
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         {
            id: 'doc_no',
            header: getColumnInfo('doc No').title,
            accessor: 'doc_no',
            isShow: getColumnInfo('doc_no').isShow,
            color: getColumnInfo('doc_no').color,
            isBold: getColumnInfo('doc_no').isBold,
            isItalic: getColumnInfo('doc_no').isItalic,
            orderNo: getColumnInfo('doc_no').orderNo,
            flex: getColumnInfo('doc_no').flex,
            cell: (info) => info.getValue() || '-',
         },
         {
            id: 'transaction_date',
            header: getColumnInfo('date').title,
            accessor: 'transaction_date',
            isShow: getColumnInfo('transaction_date').isShow,
            color: getColumnInfo('transaction_date').color,
            isBold: getColumnInfo('transaction_date').isBold,
            isItalic: getColumnInfo('transaction_date').isItalic,
            orderNo: getColumnInfo('transaction_date').orderNo,
            flex: getColumnInfo('transaction_date').flex,
            cell: (info) => formatDateToDDMMYYYY(info.getValue()),
         },
         {
            id: 'itemName',
            header: getColumnInfo('item').title,
            accessor: 'itemName',
            isShow: getColumnInfo('itemName').isShow,
            color: getColumnInfo('itemName').color,
            isBold: getColumnInfo('itemName').isBold,
            isItalic: getColumnInfo('itemName').isItalic,
            orderNo: getColumnInfo('itemName').orderNo,
            flex: getColumnInfo('itemName').flex,
         },
         {
            id: 'serialNo',
            header: getColumnInfo('serial No').title,
            accessor: 'serialNo',
            isShow: getColumnInfo('serialNo').isShow,
            color: getColumnInfo('serialNo').color,
            isBold: getColumnInfo('serialNo').isBold,
            isItalic: getColumnInfo('serialNo').isItalic,
            orderNo: getColumnInfo('serialNo').orderNo,
            flex: getColumnInfo('serialNo').flex,
            cell: (info) => info.getValue() || '-',
         },
      ];

      // Add columns specific to status types
      if (statusType === 'partyIssued') {
         baseColumns.push(
            {
               id: 'accountName',
               header: getColumnInfo('account').title,
               accessor: 'accountName',
               isShow: getColumnInfo('accountName').isShow,
               color: getColumnInfo('accountName').color,
               isBold: getColumnInfo('accountName').isBold,
               isItalic: getColumnInfo('accountName').isItalic,
               orderNo: getColumnInfo('accountName').orderNo,
               flex: getColumnInfo('accountName').flex,
            },
            {
               id: 'receive_accountName',
               header: getColumnInfo('receive account').title,
               accessor: 'receive_accountName',
               isShow: getColumnInfo('receive_accountName').isShow,
               color: getColumnInfo('receive_accountName').color,
               isBold: getColumnInfo('receive_accountName').isBold,
               isItalic: getColumnInfo('receive_accountName').isItalic,
               orderNo: getColumnInfo('receive_accountName').orderNo,
               flex: getColumnInfo('receive_accountName').flex,
            },
            {
               id: 'issue_days',
               header: getColumnInfo('issue days').title,
               accessor: 'issue_days',
               isShow: getColumnInfo('issue days').isShow,
               color: getColumnInfo('issue_days').color,
               isBold: getColumnInfo('issue_days').isBold,
               isItalic: getColumnInfo('issue_days').isItalic,
               orderNo: getColumnInfo('issue_days').orderNo,
               flex: getColumnInfo('issue_days').flex,
               cell: (info) => info.getValue() || '-',
            },
            {
               id: 'receive_days',
               header: getColumnInfo('receive days').title,
               accessor: 'receive_days',
               isShow: getColumnInfo('receive_days').isShow,
               color: getColumnInfo('receive_days').color,
               isBold: getColumnInfo('receive_days').isBold,
               isItalic: getColumnInfo('receive_days').isItalic,
               orderNo: getColumnInfo('receive_days').orderNo,
               flex: getColumnInfo('receive_days').flex,
            },
            {
               id: 'receive_issue_days',
               header: getColumnInfo('receive issue days').title,
               accessor: 'receive_issue_days',
               isShow: getColumnInfo('receive_issue_days').isShow,
               color: getColumnInfo('receive_issue_days').color,
               isBold: getColumnInfo('receive_issue_days').isBold,
               isItalic: getColumnInfo('receive_issue_days').isItalic,
               orderNo: getColumnInfo('receive_issue_days').orderNo,
               flex: getColumnInfo('receive_issue_days').flex,
            },
         );
      } else if (statusType === 'onlyReceived') {
         baseColumns.push(
            {
               id: 'accountName',
               header: getColumnInfo('Account').title,
               accessor: 'accountName',
               isShow: getColumnInfo('accountName').isShow,
               color: getColumnInfo('accountName').color,
               isBold: getColumnInfo('accountName').isBold,
               isItalic: getColumnInfo('accountName').isItalic,
               orderNo: getColumnInfo('accountName').orderNo,
               flex: getColumnInfo('accountName').flex,
            },
            {
               id: 'daybookName',
               header: getColumnInfo('Daybook').title,
               accessor: 'daybookName',
               isShow: getColumnInfo('daybookName').isShow,
               color: getColumnInfo('daybookName').color,
               isBold: getColumnInfo('daybookName').isBold,
               isItalic: getColumnInfo('daybookName').isItalic,
               orderNo: getColumnInfo('daybookName').orderNo,
               flex: getColumnInfo('daybookName').flex,
            },
         );
      } else {
         baseColumns.push(
            {
               id: 'accountName',
               header: getColumnInfo('Account').title,
               accessor: 'accountName',
               isShow: getColumnInfo('accountName').isShow,
               color: getColumnInfo('accountName').color,
               isBold: getColumnInfo('accountName').isBold,
               isItalic: getColumnInfo('accountName').isItalic,
               orderNo: getColumnInfo('accountName').orderNo,
               flex: getColumnInfo('accountName').flex,
            },
            {
               id: 'daybookName',
               header: getColumnInfo('Daybook').title,
               accessor: 'daybookName',
               isShow: getColumnInfo('daybookName').isShow,
               color: getColumnInfo('daybookName').color,
               isBold: getColumnInfo('daybookName').isBold,
               isItalic: getColumnInfo('daybookName').isItalic,
               orderNo: getColumnInfo('daybookName').orderNo,
               flex: getColumnInfo('daybookName').flex,
            },
         );
      }

      // Add common columns
      baseColumns.push({
         id: 'pcs',
         header: getColumnInfo('pcs').title,
         accessor: 'pcs',
         isShow: getColumnInfo('pcs').isShow,
         color: getColumnInfo('pcs').color,
         isBold: getColumnInfo('pcs').isBold,
         isItalic: getColumnInfo('pcs').isItalic,
         orderNo: getColumnInfo('pcs').orderNo,
         flex: getColumnInfo('pcs').flex,
         cell: (info) => info.getValue() || '0',
      });

      return baseColumns.filter((col) => col.isShow !== false).sort((a, b) => a.orderNo - b.orderNo);
   };

   const dynamicColumns = useMemo(() => {
      const format = reportformat.find((f) => f.id === stockTypeSelected) || reportformat[0];
      return getStockReportColumns(stockTypeSelected, format);
   }, [stockTypeSelected, reportformat]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width, // default width if not defined
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   const MemoizedTableRow = React.memo(
      ({
         item,
         index,
         statusType,
         formatDateToDDMMYYYY,
         setEntityType,
         setIsOpenSingleViewinr,
         setIsOpenPurchaseReturnSingleView,
      }) => {
         const { colorMode } = useColorMode();
         const dispatch = useDispatch();
         const { user } = useUser();
         const isDark = colorMode === 'dark';

         // Text colors for light and dark mode
         const textColor = isDark ? 'whiteAlpha.900' : 'gray.800';

         const columns = getStockReportColumns(statusType);

         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);

            if (data.companyId === companyId && statusType === 'onlyReceived') {
               setEntityType('receiveinventory');
               const response = await dispatch(getReceiveInventory(data.receive_header_id));
               console.log('Receive Response:', response); // Debug
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenPurchaseReturnSingleView(true); // ✅ यहाँ same modal use करें
            } else if (
               (data.companyId === companyId && statusType === 'storeIssued') ||
               (data.companyId === companyId && statusType === 'partyIssued')
            ) {
               setEntityType('issueinventory');
               const response = await dispatch(getIssueInventory(data.issue_header_id));
               console.log('Issue Response:', response); // Debug
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenPurchaseReturnSingleView(true); // ✅ यहाँ same modal use करें
            } else if (
               (data.companyId === companyId && statusType === 'storeRepairingReceived') ||
               (data.companyId === companyId && statusType === 'partyPendingSales')
            ) {
               setEntityType('purchaseinvoice');
               await dispatch(getPurchaseInvoice(data.purchase_header_id));
               setIsOpenPurchaseReturnSingleView(true);
            } else if (data.companyId === companyId && statusType === 'partyRepairingSold') {
               setEntityType('saleinvoice');
               await dispatch(getSaleInvoice(data.sale_header_id));
               setIsOpenPurchaseReturnSingleView(true);
            }
         };
         const isOddRow = index % 2 !== 0;
         return (
            <Tr
               onClick={() => handledata(item)}
               cursor="pointer"
               className={`transition-all duration-300 ${
                  isOddRow
                     ? isDark
                        ? 'bg-slate-800 bg-opacity-40 hover:bg-slate-700 hover:bg-opacity-60 hover:shadow-md'
                        : 'bg-blue-50 bg-opacity-50 hover:bg-blue-100 hover:shadow-sm'
                     : isDark
                     ? 'bg-transparent hover:bg-slate-800 hover:bg-opacity-30 hover:shadow-md'
                     : 'bg-white hover:bg-gray-50 hover:shadow-sm'
               }`}>
               {columns.map((column) => (
                  <Td
                     key={column.id}
                     color={textColor}
                     flex={column.flex}
                     className={`${isDark ? 'text-gray-100' : 'text-gray-800'} py-3 px-4 font-medium`}>
                     {column.cell ? column.cell({ getValue: () => item[column.accessor] }) : item[column.accessor]}
                  </Td>
               ))}
            </Tr>
         );
      },
   );

   const MemoizedStatusSection = React.memo(
      ({
         statusType,
         data,
         formatStatusTypeName,
         isExpanded,
         onToggleExpand,
         setEntityType,
         setIsOpenSingleViewinr,
         setIsOpenPurchaseReturnSingleView,
      }) => {
         const { colorMode } = useColorMode();
         const isDark = colorMode === 'dark';

         const columns = useMemo(() => getStockReportColumns(statusType), [statusType]);

         return (
            <Box
               key={statusType}
               mb={4}
               className={`rounded-lg overflow-hidden shadow-lg ${isDark ? 'shadow-slate-900' : 'shadow-slate-200'}`}>
               <Flex
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  cursor="pointer"
                  onClick={() => onToggleExpand(statusType)}
                  className={`${
                     isDark
                        ? 'bg-gradient-to-r from-violet-900 via-purple-900 to-indigo-900 border-l-4 border-violet-400'
                        : 'bg-gradient-to-r from-orange-50 via-amber-50 to-orange-50 border-l-4 border-orange-500'
                  } px-3 py-2 transition-all duration-300 hover:shadow-xl`}>
                  <Text
                     fontSize="md"
                     fontWeight="bold"
                     className={`${isDark ? 'text-violet-100 tracking-wide' : 'text-orange-900 tracking-wide'}`}>
                     {formatStatusTypeName(statusType)}
                  </Text>
                  <Box
                     className={`${isDark ? 'text-violet-200' : 'text-orange-600'} transition-transform duration-300 ${
                        isExpanded ? 'rotate-180' : ''
                     }`}>
                     {isExpanded ? <ChevronUpIcon boxSize={6} /> : <ChevronDownIcon boxSize={6} />}
                  </Box>
               </Flex>

               {isExpanded && (
                  <Box className={`${isDark ? 'bg-slate-900' : 'bg-white'}`}>
                     <Table variant="simple" size="sm">
                        <Thead
                           className={`${
                              isDark
                                 ? 'bg-slate-800 border-b-2 border-slate-700'
                                 : 'bg-gradient-to-r from-slate-100 to-gray-100 border-b-2 border-slate-300'
                           }`}>
                           <Tr>
                              {columns.map((column) => (
                                 <Th
                                    key={column.id}
                                    flex={column.flex}
                                    className={`${
                                       isDark
                                          ? 'text-slate-300 font-bold uppercase tracking-wider'
                                          : 'text-slate-700 font-bold uppercase tracking-wider'
                                    } py-4 px-4`}>
                                    {column.header}
                                 </Th>
                              ))}
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data.map((item, index) => (
                              <MemoizedTableRow
                                 key={`${statusType}-${index}`}
                                 item={item}
                                 index={index + 1}
                                 statusType={statusType}
                                 formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                                 setEntityType={setEntityType}
                                 setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                                 setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                              />
                           ))}
                        </Tbody>
                     </Table>
                  </Box>
               )}
            </Box>
         );
      },
   );

   const toggleSection = useCallback((section) => {
      setExpandedSections((prev) => ({
         ...prev,
         [section]: !prev[section],
      }));
   }, []);

   const exportToExcel = () => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      // Create a new workbook
      const wb = XLSX.utils.book_new();

      // Define styles
      const styles = {
         header: {
            fill: { fgColor: { rgb: 'F5F5F5' } },
            font: { bold: true, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
            border: {
               top: { style: 'thin', color: { rgb: '000000' } },
               bottom: { style: 'thin', color: { rgb: '000000' } },
               left: { style: 'thin', color: { rgb: '000000' } },
               right: { style: 'thin', color: { rgb: '000000' } },
            },
         },
         title: {
            fill: { fgColor: { rgb: 'E6E6E6' } },
            font: { bold: true, size: 14, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
         },
         subtitle: {
            fill: { fgColor: { rgb: 'EDEDED' } },
            font: { bold: true, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
         },
         cell: {
            border: {
               top: { style: 'thin', color: { rgb: 'DDDDDD' } },
               bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               left: { style: 'thin', color: { rgb: 'DDDDDD' } },
               right: { style: 'thin', color: { rgb: 'DDDDDD' } },
            },
         },
         evenRow: {
            fill: { fgColor: { rgb: 'EFF6FF' } },
         },
      };

      salesReport.forEach((companyData) => {
         const allData = [];
         let maxColumns = 0;

         // Add company title
         allData.push([companyData.companyName]);
         allData.push([]); // Empty row

         Object.keys(companyData).forEach((key) => {
            if (key === 'companyId' || key === 'companyName') return;

            const statusType = key;
            const data = companyData[statusType];
            if (!data || data.length === 0) return;

            // Add section title
            allData.push([formatStatusTypeName(statusType)]);
            allData.push([]); // Empty row

            // Determine headers
            let headers;
            if (statusType === 'onlyReceived') {
               headers = ['Doc No', 'Date', 'Item', 'Serial No', 'Account', 'Daybook', 'Pcs'];
            } else if (statusType === 'partyIssued') {
               headers = [
                  'Doc No',
                  'Date',
                  'Item',
                  'Serial No',
                  'Issue Account',
                  'Receive Account',
                  'Issue Days',
                  'Receive Days',
                  'Issue Receive Days',
                  'Pcs',
               ];
            } else {
               headers = ['Doc No', 'Date', 'Item', 'Serial No', 'Account', 'Daybook', 'Pcs'];
            }

            maxColumns = Math.max(maxColumns, headers.length);
            allData.push(headers);

            // Add data rows
            data.forEach((item, index) => {
               const row = [];
               if (statusType === 'onlyReceived') {
                  row.push(
                     item.doc_no || '-',
                     formatDateToDDMMYYYY(item.transaction_date),
                     item.itemName,
                     item.serialNo || '-',
                     item.accountName,
                     item.daybookName,
                     item.pcs || '0',
                  );
               } else if (statusType === 'partyIssued') {
                  row.push(
                     item.doc_no || '-',
                     formatDateToDDMMYYYY(item.transaction_date),
                     item.itemName,
                     item.serialNo || '-',
                     item.accountName,
                     item.receive_accountName,
                     item.issue_days || '-',
                     item.receive_days,
                     item.receive_issue_days,
                     item.pcs || '0',
                  );
               } else {
                  row.push(
                     item.doc_no || '-',
                     formatDateToDDMMYYYY(item.transaction_date),
                     item.itemName,
                     item.serialNo || '-',
                     item.accountName,
                     item.daybookName,
                     item.pcs || '0',
                  );
               }
               allData.push(row);
            });

            allData.push([]); // Empty row between sections
         });

         // Remove last empty row if exists
         if (allData.length > 0 && allData[allData.length - 1].length === 0) {
            allData.pop();
         }

         // Create worksheet
         const ws = XLSX.utils.aoa_to_sheet(allData);

         // Apply styles
         const range = XLSX.utils.decode_range(ws['!ref']);
         for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
               const cellAddress = { c: C, r: R };
               const cellRef = XLSX.utils.encode_cell(cellAddress);

               if (!ws[cellRef]) continue;

               // Company title
               if (R === 0) {
                  ws[cellRef].s = styles.title;
               }
               // Section titles
               else if (
                  allData[R] &&
                  allData[R].length === 1 &&
                  (allData[R][0] === formatStatusTypeName('onlyReceived') ||
                     allData[R][0] === formatStatusTypeName('partyIssued') ||
                     allData[R][0] === formatStatusTypeName('storeIssued'))
               ) {
                  ws[cellRef].s = styles.subtitle;
               }
               // Headers
               else if (allData[R] && allData[R][0] === 'Doc No') {
                  ws[cellRef].s = styles.header;
               }
               // Data rows
               else {
                  ws[cellRef].s = styles.cell;
                  // Alternate row colors
                  if (R % 2 === 0) {
                     ws[cellRef].s = { ...ws[cellRef].s, ...styles.evenRow };
                  }
               }
            }
         }

         // Merge title cells
         ws['!merges'] = ws['!merges'] || [];
         ws['!merges'].push({
            s: { r: 0, c: 0 },
            e: { r: 0, c: maxColumns - 1 },
         });

         // Merge section title cells
         for (let R = 0; R < allData.length; R++) {
            if (
               allData[R] &&
               allData[R].length === 1 &&
               (allData[R][0] === formatStatusTypeName('onlyReceived') ||
                  allData[R][0] === formatStatusTypeName('partyIssued') ||
                  allData[R][0] === formatStatusTypeName('storeIssued'))
            ) {
               ws['!merges'].push({
                  s: { r: R, c: 0 },
                  e: { r: R, c: maxColumns - 1 },
               });
            }
         }

         // Set column widths
         ws['!cols'] = Array(maxColumns)
            .fill(null)
            .map((_, i) => {
               if (i === 2) return { wch: 30 }; // Item column
               if (i === 3) return { wch: 25 }; // Serial No column
               return { wch: 15 }; // Default width
            });

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, companyData.companyName.substring(0, 31));
      });

      // Generate Excel file
      const now = new Date();
      const dateStr = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now
         .getDate()
         .toString()
         .padStart(2, '0')}`;
      XLSX.writeFile(wb, `Party_Stock_Report_${dateStr}.xlsx`);
   };

   const exportToPDF = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document in landscape mode for better table display
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Define styles
         const styles = {
            title: {
               fontSize: 16,
               fontStyle: 'bold',
               textColor: [0, 0, 0],
               halign: 'center',
               marginBottom: 10,
            },
            subtitle: {
               fontSize: 12,
               fontStyle: 'bold',
               textColor: [0, 0, 0],
               halign: 'center',
               marginBottom: 15,
            },
            companyHeader: {
               fontSize: 14,
               fontStyle: 'bold',
               textColor: [0, 0, 0],
               fillColor: [230, 230, 230],
               marginBottom: 5,
            },
            sectionHeader: {
               fontSize: 12,
               fontStyle: 'bold',
               textColor: [0, 0, 0],
               fillColor: [245, 245, 245],
               marginBottom: 5,
            },
            tableHeader: {
               fillColor: [245, 245, 245],
               textColor: [0, 0, 0],
               fontStyle: 'bold',
            },
            oddRow: {
               fillColor: [255, 255, 255],
               textColor: [0, 0, 0],
            },
            evenRow: {
               fillColor: [239, 246, 255],
               textColor: [0, 0, 0],
            },
         };

         // Add title and date range
         doc.setFontSize(styles.title.fontSize);
         doc.setFont('helvetica', styles.title.fontStyle);
         doc.setTextColor(...styles.title.textColor);
         doc.text('Party Stock Report', doc.internal.pageSize.width / 2, 15, {
            align: styles.title.halign,
         });

         doc.setFontSize(styles.subtitle.fontSize);
         doc.setFont('helvetica', styles.subtitle.fontStyle);
         doc.setTextColor(...styles.subtitle.textColor);
         doc.text(
            `From ${formatDateToDDMMYYYY(dateRange?.fromDate || '')} to ${formatDateToDDMMYYYY(
               dateRange?.toDate || '',
            )}`,
            doc.internal.pageSize.width / 2,
            25,
            { align: styles.subtitle.halign },
         );

         let startY = 35;

         // Process each company's data
         salesReport.forEach((companyData) => {
            // Add company header
            doc.setFontSize(styles.companyHeader.fontSize);
            doc.setFont('helvetica', styles.companyHeader.fontStyle);
            doc.setTextColor(...styles.companyHeader.textColor);
            doc.text(companyData.companyName, 14, startY);

            startY += 7;

            // Process each status type for this company
            Object.keys(companyData).forEach((key) => {
               if (key === 'companyId' || key === 'companyName') return;

               const statusType = key;
               const data = companyData[statusType];
               if (!data || data.length === 0) return;

               // Add section header
               doc.setFontSize(styles.sectionHeader.fontSize);
               doc.setFont('helvetica', styles.sectionHeader.fontStyle);
               doc.setTextColor(...styles.sectionHeader.textColor);
               doc.text(formatStatusTypeName(statusType), 14, startY);

               startY += 5;

               // Define columns based on status type
               let columns;
               let columnStyles = {};

               if (statusType === 'onlyReceived') {
                  columns = [
                     { header: 'Doc No', dataKey: 'doc_no', width: 15 },
                     { header: 'Date', dataKey: 'date', width: 20 },
                     { header: 'Item', dataKey: 'itemName', width: 40 },
                     { header: 'Serial No', dataKey: 'serialNo', width: 30 },
                     { header: 'Account', dataKey: 'accountName', width: 30 },
                     { header: 'Daybook', dataKey: 'daybookName', width: 30 },
                     { header: 'Pcs', dataKey: 'pcs', width: 10 },
                  ];
                  columnStyles = {
                     7: { halign: 'right' },
                  };
               } else if (statusType === 'partyIssued') {
                  columns = [
                     { header: 'Doc No', dataKey: 'doc_no', width: 15 },
                     { header: 'Date', dataKey: 'date', width: 20 },
                     { header: 'Item', dataKey: 'itemName', width: 40 },
                     { header: 'Serial No', dataKey: 'serialNo', width: 30 },
                     { header: 'Issue Account', dataKey: 'accountName', width: 30 },
                     { header: 'Receive Account', dataKey: 'receive_accountName', width: 30 },
                     { header: 'Issue Days', dataKey: 'issue_days', width: 15 },
                     { header: 'Receive Days', dataKey: 'receive_days', width: 15 },
                     { header: 'Issue Receive Days', dataKey: 'receive_issue_days', width: 15 },
                     { header: 'Pcs', dataKey: 'pcs', width: 10 },
                  ];
                  columnStyles = {
                     6: { halign: 'right' },
                     7: { halign: 'right' },
                     8: { halign: 'right' },
                     9: { halign: 'right' },
                  };
               } else {
                  columns = [
                     { header: 'Doc No', dataKey: 'doc_no', width: 15 },
                     { header: 'Date', dataKey: 'date', width: 20 },
                     { header: 'Item', dataKey: 'itemName', width: 40 },
                     { header: 'Serial No', dataKey: 'serialNo', width: 30 },
                     { header: 'Account', dataKey: 'accountName', width: 30 },
                     { header: 'Daybook', dataKey: 'daybookName', width: 30 },
                     { header: 'Pcs', dataKey: 'pcs', width: 10 },
                  ];
                  columnStyles = {
                     6: { halign: 'right' },
                  };
               }

               // Prepare table data
               const tableData = data.map((item) => {
                  const row = {
                     doc_no: item.doc_no || '-',
                     date: formatDateToDDMMYYYY(item.transaction_date),
                     itemName: item.itemName,
                     serialNo: item.serialNo || '-',
                     pcs: item.pcs || '0',
                  };

                  if (statusType === 'onlyReceived') {
                     row.accountName = item.accountName;
                     row.daybookName = item.daybookName;
                  } else if (statusType === 'partyIssued') {
                     row.accountName = item.accountName;
                     row.receive_accountName = item.receive_accountName;
                     row.issue_days = item.issue_days || '-';
                     row.receive_days = item.receive_days;
                     row.receive_issue_days = item.receive_issue_days;
                  } else {
                     row.accountName = item.accountName;
                     row.daybookName = item.daybookName;
                  }

                  return row;
               });

               // Add table to PDF with adjusted settings
               doc.autoTable({
                  columns,
                  body: tableData,
                  startY,
                  margin: { left: 14, right: 14 },
                  headStyles: {
                     fillColor: styles.tableHeader.fillColor,
                     textColor: styles.tableHeader.textColor,
                     fontStyle: styles.tableHeader.fontStyle,
                     fontSize: 9,
                  },
                  bodyStyles: {
                     fontSize: 8,
                     cellPadding: 2,
                     overflow: 'linebreak',
                  },
                  alternateRowStyles: {
                     fillColor: styles.evenRow.fillColor,
                  },
                  styles: {
                     textColor: [0, 0, 0],
                     // fontStyle: 'bold',
                  },
                  columnStyles,
                  didDrawPage: (data) => {
                     startY = data.cursor.y + 5;
                  },
               });

               startY += 5;
            });

            startY += 10;

            if (startY > doc.internal.pageSize.height - 20) {
               doc.addPage();
               startY = 20;
            }
         });

         const now = new Date();
         const safeFileName = `Party_Stock_Report_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   }, [salesReport, dateRange, formatDateToDDMMYYYY, formatStatusTypeName]);

   const renderStockReport = useMemo(() => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      if (!salesReport || salesReport.length === 0) {
         return (
            <Box textAlign="center" py={10}>
               <Flex direction="column" align="center" justify="center">
                  <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                  <Text mt={4} color={textColor}>
                     No stock data found
                  </Text>
               </Flex>
            </Box>
         );
      }

      return salesReport.map((companyData) => {
         const statusTypes = Object.keys(companyData).filter(
            (key) => key !== 'companyId' && key !== 'companyName' && companyData[key] && companyData[key].length > 0,
         );

         if (statusTypes.length === 0) {
            return null;
         }

         const companyHeaderBgColor = isDarkMode ? 'blue.900' : 'orange.50';
         const companyHeaderTextColor = isDarkMode ? 'whiteAlpha.900' : 'gray.800';

         return (
            <Box key={companyData.companyId} mb={8}>
               <Text
                  fontSize="xl"
                  fontWeight="bold"
                  pl={2}
                  py={1}
                  className={`${
                     isDarkMode
                        ? 'bg-gradient-to-r from-indigo-900 via-purple-900 to-indigo-900 text-indigo-100 border-l-4 border-indigo-400'
                        : 'bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-50 text-indigo-900 border-l-4 border-indigo-500'
                  } tracking-wide shadow-md transition-all duration-300 hover:shadow-lg`}>
                  {companyData.companyName}
               </Text>

               {statusTypes.map((statusType) => (
                  <MemoizedStatusSection
                     key={`${companyData.companyId}-${statusType}`}
                     statusType={statusType}
                     data={companyData[statusType]}
                     formatStatusTypeName={formatStatusTypeName}
                     formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                     isExpanded={expandedSections[statusType] || false}
                     onToggleExpand={toggleSection}
                     setEntityType={setEntityType}
                     setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                     setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                  />
               ))}
            </Box>
         );
      });
   }, [
      isLoading,
      salesReport,
      table,
      formatStatusTypeName,
      formatDateToDDMMYYYY,
      expandedSections,
      toggleSection,
      isDarkMode,
      textColor,
   ]);

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      if (entityType === 'saleinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deleteSaleInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'purchaseinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      } else if (entityType === 'issueinventory') {
         // Issue delete logic यहाँ add करें
         console.log('Delete Issue:', viewDetail?.id);
         // dispatch(deleteIssueInventory(viewDetail?.id));
      } else if (entityType === 'receiveinventory') {
         // Receive delete logic यहाँ add करें
         console.log('Delete Receive:', viewDetail?.id);
         // dispatch(deleteReceiveInventory(viewDetail?.id));
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === stockTypeSelected);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Party Stock
               </Text>
            </Flex>
            <Flex gap={2}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <HiOutlinePlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        mt={5}
                        fontWeight={500}
                        display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Flex>

               <Flex flex="" display={{ base: 'none', xl: 'flex' }} mr={3}>
                  <Box my={2} width="170px" fontSize="13px" fontWeight={500}>
                     <label>Store Stock Type</label>
                     <Select
                        placeholder="Select Stock-Status"
                        name="Stock-Status"
                        options={storeStockType.map((comp) => ({ value: comp.id, label: comp.name }))}
                        value={stockTypeSelected}
                        onChange={setStockTypeSelected}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Flex>

               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>

               <Flex flex="1"></Flex>

               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>

                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <HiOutlineRefresh size={20} mr={2} />
                  </Button>

                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>

                  <Popover>
                     <PopoverTrigger>
                        <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToExcel}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Excel
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToPDF}
                              justifyContent="space-between">
                              <img src={xls} alt="Download pdf" width="30px" mr></img>
                              Download Pdf
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>{renderStockReport}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <SalesPurchaseFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            type={stockTypeSelected?.value}
            entityType={'storeStock'}
         />
         {/* <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={entityType === 'saleinvoice' ? 'Sales Invoice' : 'Purchase Invoice'}
            entityType={entityType}
            singleEntity={viewDetail}
            setIsEditFormOpen={setIsEditFormOpen}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         /> */}
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={
               saleInvoiceRight ||
               saleReturnRight ||
               purchaseInvoiceRight ||
               purchaseReturnRight ||
               IssueRight ||
               ReceiveRight
            }
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'purchaseinvoice'
                  ? 'Purchase Invoice'
                  : entityType === 'issueinventory'
                  ? 'Issue'
                  : entityType === 'receiveinventory'
                  ? 'Receive'
                  : null
            }
            entityType={entityType}
            singleEntity={viewDetail}
            setIsEditFormOpen={setIsEditFormOpen}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            // selectedFormat={storeStockTypeOptions.dynamicOptions}
            // FixdefName1={'SalesDetailDate'}
            // FixdefName2={'SalesDetailParty'}
            // FixdefName3={'SalesDetailBroker'}
            // staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />
      </>
   );
};

export default Stock;
